import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import isEmail from 'validator/es/lib/isEmail';
import { usePasswordReset } from '../../hooks';
import { IFormInput } from '../Form';
import LandingTemplate from '../LandingTemplate';

export default function InitiatePasswordReset() {
  const formHook = useForm();
  const [initiationSucceeded, setInitiationSucceeded] = useState(false);

  const { initiatePasswordReset } = usePasswordReset();

  const inputs: IFormInput[] = [
    {
      name: 'email',
      label: 'Email Address',
      type: 'email',
      validate: {
        email: value => isEmail(value)
      },
      required: true
    }
  ];

  const onSubmit = (data: any) => {
    initiatePasswordReset(data.email)
      .then(() => setInitiationSucceeded(true))
      .catch(() => { });
  };

  const resetPasswordInitiatedMessage = 'Please check your mailbox to proceed with password reset';

  return <LandingTemplate
    form={{ submitCaption: "Reset Password", inputs, onSubmit, formHook }}
    successFullSubmitMessage={(initiationSucceeded && resetPasswordInitiatedMessage) || undefined}
  />;
}